import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

class NewsService {
  static cachedNews = null;
  static _unsubscribe = null;
  static _listeners = new Set();

 

  static subscribe(callback) {
    this._listeners.add(callback);

    // İlk kez subscribe ediliyorsa Firestore bağlantısını kur
    if (!this._unsubscribe) {
      const q = query(collection(db, "haberler"), orderBy("createdAt", "desc"));
      this._unsubscribe = onSnapshot(q, snap => {
        const fbNews = snap.docs.map(doc => {
          const d = doc.data();
          return {
            id: doc.id,
            title: d.title || "",
            content: d.content || "",
            excerpt: this.getExcerpt(d.content || ""),
            date: d.createdAt?.toDate?.()?.toISOString() ?? new Date().toISOString(),
            imageUrl: d.imageUrl || "",
            extraImages: d.extraImages || [],
            source: "fb",
          };
        });

        const merged = [...fbNews]
          .sort((a, b) => new Date(b.date) - new Date(a.date));

        this.cachedNews = merged;
        this._listeners.forEach(cb => cb(merged));
      });
    } else if (this.cachedNews) {
      // Zaten veri varsa hemen tetikle
      callback(this.cachedNews);
    }

    // Unsubscribe fonksiyonu döndür
    return () => {
      this._listeners.delete(callback);
      if (this._listeners.size === 0 && this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    };
  }

  // Geriye dönük uyumluluk — sync erişim (cache doluysa)
  static getNews() {
    return this.cachedNews ?? this._parseJson();
  }

  static getLatestNews(limit = 5) {
    return this.getNews().slice(0, limit);
  }

  static getNewsById(id) {
    const allNews = this.getNews();
    return allNews.find((news) => news.id === id) || null;
  }

  static getExcerpt(content, maxLength = 150) {
    // HTML etiketlerini temizle
    if (!content) return "";
    const text = content.replace(/<[^>]*>/g, "");
    // Fazla boşlukları temizle
    const cleanText = text.replace(/\s+/g, " ").trim();
    // Belirtilen uzunlukta kes
    if (cleanText.length > maxLength) {
      return cleanText.substring(0, maxLength) + "...";
    }
    return cleanText;
  }

  static formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("tr-TR", options);
  }

  static clearCache() {
    this.cachedNews = null;
  }
}

export default NewsService;